import { Network } from '../interfaces/network'
import { BICONOMY, PIMLICO } from './bundlers'

const networks: Network[] = [
  {
    name: 'Ethereum',
    nativeAssetSymbol: 'ETH',
    has7702: true,
    nativeAssetName: 'Ether',
    rpcUrls: [
      'https://apis.zkxwallet.com/invictus/ethereum',
      'https://ethereum-rpc.publicnode.com',
      'https://eth.drpc.org'
    ],
    selectedRpcUrl: 'https://apis.zkxwallet.com/invictus/ethereum',
    rpcNoStateOverride: false,
    chainId: 1n,
    explorerUrl: 'https://etherscan.io',
    erc4337: { enabled: false, hasPaymaster: true, hasBundlerSupport: true },
    isSAEnabled: true,
    areContractsDeployed: true,
    hasRelayer: true,
    platformId: 'ethereum',
    nativeAssetId: 'ethereum',
    hasSingleton: true,
    features: [],
    feeOptions: { is1559: true },
    predefined: true,
    wrappedAddr: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    disableEstimateGas: true
  },
  {
    name: 'Polygon',
    nativeAssetSymbol: 'POL',
    has7702: true,
    nativeAssetName: 'Polygon',
    rpcUrls: [
      'https://apis.zkxwallet.com/invictus/polygon',
      'https://polygon-bor-rpc.publicnode.com',
      'https://polygon.drpc.org'
    ],
    selectedRpcUrl: 'https://apis.zkxwallet.com/invictus/polygon',
    rpcNoStateOverride: false,
    chainId: 137n,
    explorerUrl: 'https://polygonscan.com',
    erc4337: {
      enabled: false,
      hasPaymaster: true,
      hasBundlerSupport: true,
      bundlers: [PIMLICO, BICONOMY],
      defaultBundler: PIMLICO
    },
    isSAEnabled: true,
    areContractsDeployed: true,
    hasRelayer: true,
    platformId: 'polygon-pos',
    nativeAssetId: 'matic-network',
    hasSingleton: true,
    features: [],
    feeOptions: { is1559: false, feeIncrease: 10n },
    predefined: true,
    wrappedAddr: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
    oldNativeAssetSymbols: ['MATIC'],
    disableEstimateGas: true
  },
  {
    name: 'OP Mainnet',
    nativeAssetSymbol: 'ETH',
    has7702: true,
    nativeAssetName: 'Ether',
    rpcUrls: [
      'https://apis.zkxwallet.com/invictus/optimism',
      'https://optimism-rpc.publicnode.com',
      'https://mainnet.optimism.io'
    ],
    selectedRpcUrl: 'https://apis.zkxwallet.com/invictus/optimism',
    rpcNoStateOverride: false,
    chainId: 10n,
    explorerUrl: 'https://optimistic.etherscan.io',
    erc4337: {
      enabled: true,
      hasPaymaster: true,
      hasBundlerSupport: true,
      bundlers: [PIMLICO, BICONOMY],
      defaultBundler: BICONOMY,
      increasePreVerGas: 5
    },
    isSAEnabled: true,
    areContractsDeployed: true,
    hasRelayer: true,
    platformId: 'optimistic-ethereum',
    nativeAssetId: 'ethereum',
    hasSingleton: true,
    features: [],
    feeOptions: {
      is1559: true,
      elasticityMultiplier: 6n,
      baseFeeMaxChangeDenominator: 50n
    },
    isOptimistic: true,
    predefined: true,
    disableEstimateGas: true,
    wrappedAddr: '0x4200000000000000000000000000000000000006'
  },
  {
    name: 'Avalanche',
    nativeAssetSymbol: 'AVAX',
    has7702: false,
    nativeAssetName: 'Avalanche',
    rpcUrls: [
      'https://apis.zkxwallet.com/invictus/avalanche',
      'https://avalanche-c-chain-rpc.publicnode.com',
      'https://api.avax.network/ext/bc/C/rpc'
    ],
    selectedRpcUrl: 'https://apis.zkxwallet.com/invictus/avalanche',
    rpcNoStateOverride: false,
    chainId: 43114n,
    explorerUrl: 'https://snowtrace.io',
    erc4337: {
      enabled: true,
      hasPaymaster: true,
      hasBundlerSupport: true
    },
    isSAEnabled: true,
    areContractsDeployed: true,
    hasRelayer: true,
    platformId: 'avalanche',
    nativeAssetId: 'avalanche-2',
    hasSingleton: true,
    features: [],
    feeOptions: {
      is1559: true,
      minBaseFee: 25000000000n // 25 gwei
    },
    predefined: true,
    disableEstimateGas: true,
    wrappedAddr: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7'
  },
  {
    name: 'Arbitrum',
    nativeAssetSymbol: 'ETH',
    has7702: true,
    nativeAssetName: 'Ether',
    rpcUrls: [
      'https://apis.zkxwallet.com/invictus/arbitrum',
      'https://arbitrum-one-rpc.publicnode.com',
      'https://arb1.arbitrum.io/rpc'
    ],
    selectedRpcUrl: 'https://apis.zkxwallet.com/invictus/arbitrum',
    rpcNoStateOverride: false,
    chainId: 42161n,
    explorerUrl: 'https://arbiscan.io',
    erc4337: {
      enabled: true,
      hasPaymaster: true,
      hasBundlerSupport: true,
      bundlers: [PIMLICO, BICONOMY],
      defaultBundler: PIMLICO
    },
    isSAEnabled: true,
    areContractsDeployed: true,
    hasRelayer: true,
    platformId: 'arbitrum-one',
    nativeAssetId: 'ethereum',
    hasSingleton: true,
    features: [],
    feeOptions: {
      is1559: true,
      minBaseFee: 100000000n // 1 gwei
    },
    predefined: true,
    wrappedAddr: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1'
  },
  {
    name: 'Base',
    nativeAssetSymbol: 'ETH',
    has7702: true,
    nativeAssetName: 'Ether',
    rpcUrls: [
      'https://apis.zkxwallet.com/invictus/base',
      'https://base-rpc.publicnode.com',
      'https://mainnet.base.org'
    ],
    selectedRpcUrl: 'https://apis.zkxwallet.com/invictus/base',
    rpcNoStateOverride: false,
    chainId: 8453n,
    explorerUrl: 'https://basescan.org',
    erc4337: {
      enabled: true,
      hasPaymaster: true,
      hasBundlerSupport: true,
      bundlers: [PIMLICO, BICONOMY],
      defaultBundler: PIMLICO,
      increasePreVerGas: 5
    },
    isSAEnabled: true,
    areContractsDeployed: true,
    hasRelayer: true,
    platformId: 'base',
    nativeAssetId: 'ethereum',
    hasSingleton: true,
    isOptimistic: true,
    features: [],
    feeOptions: {
      is1559: true,
      minBaseFeeEqualToLastBlock: true
    },
    predefined: true,
    disableEstimateGas: true,
    wrappedAddr: '0x4200000000000000000000000000000000000006'
  },
  {
    name: 'Scroll',
    nativeAssetSymbol: 'ETH',
    has7702: false,
    nativeAssetName: 'Ether',
    rpcUrls: [
      'https://apis.zkxwallet.com/invictus/scroll',
      'https://rpc.scroll.io',
      'https://scroll-rpc.publicnode.com'
    ],
    selectedRpcUrl: 'https://apis.zkxwallet.com/invictus/scroll',
    rpcNoStateOverride: false,
    chainId: 534352n,
    explorerUrl: 'https://scrollscan.com',
    erc4337: {
      enabled: false,
      hasPaymaster: true,
      hasBundlerSupport: true
    },
    isSAEnabled: true,
    areContractsDeployed: true,
    hasRelayer: true,
    platformId: 'scroll',
    nativeAssetId: 'ethereum',
    hasSingleton: true,
    features: [],
    feeOptions: { is1559: false },
    predefined: true,
    disableEstimateGas: true,
    wrappedAddr: '0x5300000000000000000000000000000000000004'
  },
  {
    name: 'BNB Smart Chain',
    nativeAssetSymbol: 'BNB',
    has7702: true,
    nativeAssetName: 'Binance Coin',
    rpcUrls: [
      'https://apis.zkxwallet.com/invictus/binance-smart-chain',
      'https://bsc-rpc.publicnode.com',
      'https://bsc-dataseed.bnbchain.org'
    ],
    selectedRpcUrl: 'https://apis.zkxwallet.com/invictus/binance-smart-chain',
    rpcNoStateOverride: false,
    chainId: 56n,
    explorerUrl: 'https://bscscan.com/',
    erc4337: {
      enabled: false,
      hasPaymaster: true,
      hasBundlerSupport: true,
      bundlers: [PIMLICO, BICONOMY],
      defaultBundler: PIMLICO
    },
    isSAEnabled: true,
    areContractsDeployed: true,
    hasRelayer: true,
    platformId: 'binance-smart-chain',
    nativeAssetId: 'binancecoin',
    hasSingleton: true,
    features: [],
    feeOptions: { is1559: true },
    predefined: true,
    disableEstimateGas: true,
    wrappedAddr: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c'
  },
  {
    areContractsDeployed: false,
    chainId: 369n,
    erc4337: { enabled: false, hasPaymaster: false, hasBundlerSupport: false },
    explorerUrl: 'https://ipfs.scan.pulsechain.com',
    features: [
      {
        id: 'saSupport',
        level: 'danger',
        msg: 'We were unable to detect Smart Account support on the network with the provided RPC. Try choosing a different RPC.',
        title: 'Smart contract wallets are not supported'
      },
      {
        id: 'simulation',
        level: 'warning',
        msg: 'Transaction simulation, one of our security features that predicts the outcome of a transaction before it is broadcast to the blockchain, is not fully functioning on this chain. The reasons might be network or RPC limitations. Try choosing a different RPC.',
        title: 'Transaction simulation is partially supported'
      },
      {
        id: 'prices',
        level: 'success',
        msg: 'We pull token price information in real-time using third-party providers.',
        title: 'Token prices'
      }
    ],
    feeOptions: { is1559: false },
    flagged: false,
    has7702: false,
    hasRelayer: false,
    hasSingleton: true,
    iconUrls: [],
    isOptimistic: false,
    isSAEnabled: true,
    name: 'PulseChain',
    nativeAssetId: 'pulsechain',
    nativeAssetName: 'Pulse',
    nativeAssetSymbol: 'PLS',
    platformId: 'pulsechain',
    predefined: true,
    rpcNoStateOverride: false,
    // Primary is kept as LibertySwap's RPC because the PulseChain swap flow (Permit2)
    // depends on it; the rest are automatic failover targets, all verified to answer
    // eth_chainId + state-override eth_call. Dead endpoints (evex.cloud, owlracle,
    // hairylabs) were removed so failover doesn't waste hops on them.
    rpcUrls: [
      'https://rpc.libertyswap.finance',
      'https://pulsechain-rpc.publicnode.com',
      'https://rpc.pulsechainrpc.com',
      'https://rpc.pulsechain.com',
      'https://rpc.pulsechainstats.com',
      'https://rpc-pulsechain.g4mm4.io',
      'https://rpc.gigatheminter.com'
    ],
    selectedRpcUrl: 'https://rpc.libertyswap.finance'
  },
  {
    name: 'Mantle',
    nativeAssetSymbol: 'MNT',
    has7702: false,
    nativeAssetName: 'Mantle',
    rpcUrls: [
      'https://apis.zkxwallet.com/invictus/mantle',
      'https://mantle-rpc.publicnode.com',
      'https://rpc.mantle.xyz'
    ],
    selectedRpcUrl: 'https://apis.zkxwallet.com/invictus/mantle',
    rpcNoStateOverride: false,
    chainId: 5000n,
    explorerUrl: 'https://mantlescan.xyz/',
    erc4337: {
      enabled: true,
      hasPaymaster: true,
      hasBundlerSupport: true
    },
    isSAEnabled: true,
    areContractsDeployed: true,
    hasRelayer: false,
    platformId: 'mantle',
    nativeAssetId: 'mantle',
    hasSingleton: true,
    isOptimistic: true,
    features: [],
    feeOptions: {
      is1559: true,
      minBaseFeeEqualToLastBlock: true
    },
    predefined: true,
    disableEstimateGas: true,
    wrappedAddr: '0x78c1b0C915c4FAA5FffA6CAbf0219DA63d7f4cb8'
  },
  {
    areContractsDeployed: true,
    chainId: 4663n,
    erc4337: { enabled: true, hasPaymaster: true, hasBundlerSupport: true },
    explorerUrl: 'https://robinhoodchain.blockscout.com',
    features: [
      {
        id: 'simulation',
        level: 'warning',
        msg: 'Transaction simulation, one of our security features that predicts the outcome of a transaction before it is broadcast to the blockchain, is not fully functioning on this chain. The reasons might be network or RPC limitations. Try choosing a different RPC.',
        title: 'Transaction simulation is partially supported'
      },
      {
        id: 'prices',
        level: 'success',
        msg: 'We pull token price information in real-time using third-party providers.',
        title: 'Token prices'
      }
    ],
    feeOptions: { is1559: true },
    flagged: false,
    has7702: false,
    hasRelayer: false,
    hasSingleton: true,
    iconUrls: [],
    isOptimistic: false,
    isSAEnabled: true,
    name: 'Robinhood Chain',
    nativeAssetId: 'ethereum',
    nativeAssetName: 'Ether',
    nativeAssetSymbol: 'ETH',
    platformId: 'robinhood-chain',
    predefined: true,
    rpcNoStateOverride: false,
    rpcUrls: [
      'https://fragrant-quaint-knowledge.robinhood-mainnet.quiknode.pro/a08d3d12c5022f6ee87c38b4d3d9a43d10e05232/',
      'https://rpc.mainnet.chain.robinhood.com'
    ],
    selectedRpcUrl:
      'https://fragrant-quaint-knowledge.robinhood-mainnet.quiknode.pro/a08d3d12c5022f6ee87c38b4d3d9a43d10e05232/'
  }
]
export { networks }

export const ARBITRUM_CHAIN_ID = 42161n
export const SCROLL_CHAIN_ID = 534352n
